import React from 'react';
import VideoConference from "../Video/videoConference/videoConference";

const VideoConsult = (props) => {
    return (
        <VideoConference{...props}/>
    );
}
export default VideoConsult;
